export const HomePageId = 'Homepage';
